/**
 *  用于完成wxBridge的校验、登录态的获取，用于完成一系列涉及wxBridge的操作
 *
 *  @module jsbridge/jsbridge_login_queue
 *  @see module:jsbridge/jsbridge_base
 */
import Env from '../common/env.js';
import _wxBridge from "../jsbridge/jsbridge_async_verifycall.js";

import Dom from '../base/mdom.js';
import Base from '../base/mbase.js';
import QMAjax from '../base/ajax.js';
import Queue from '../base/queue.js';
import JsapiLog from './jsapi_log.js';
import Versions from '../config/versions.js';
import Cookie from '../base/mcookie.js';
import _qualityBase from '../quality/quality_report_base.js';

let exportData;
if(!Env.isCSR) {
    (function(win){
        var wxBridge;

        if ( win['WXGAME'] && win['WXGAME'].WxBridge ) {
            wxBridge = win['WXGAME'].WxBridge;
            exportData = wxBridge;
            return;
        } else {
            wxBridge = _wxBridge;
        }
        Dom.window.getUinKeyQueue  = Dom.window.getUinKeyQueue || new Queue();
        Dom.window.getUinKeyQueue.setRelevant();


        Dom.window.verifyJsapiQueue = Dom.window.verifyJsapiQueue || new Queue();
        Dom.window.verifyJsapiQueue.setSync();


        var getQueryStr = Base.getQueryStr;

        var location    = Dom.window.location;
        /*
         * 保证WeixinJSBridge已ready
         */
        function _callAfterReady(justCallFn) {
            var _wxBridge = this;
            wxBridge.getBridge(function(_bridge){
                justCallFn && justCallFn.call(_wxBridge, _bridge);
            });
        }

        /**
         * getUinKey函数专用模块。 此文件，其它地方不会使用。
         */
        var LoginModule = {
            firstLogin:{},
    
            /*
            * 根据jsapi返回的对象生成login信息。这里做保护。
            */
            buildLoginByObj:function(obj){
                /**
                 * full_url，是android,ios， getWepkgAuthResult 的返回。
                 * fullurl,是getA8key on事件返回的东西。。兼容老版本。
                 * url是ios下，getWepkgAuthResult的返回。
                 */
                var url = obj.full_url || obj.fullurl || obj.url || '';
    
                var uin         = getQueryStr('uin',url,Dom.window),
                    key         = getQueryStr('key',url,Dom.window) ,
                    pass_ticket = getQueryStr('pass_ticket',url,Dom.window),
                    abtest_cookie = getQueryStr('abtest_cookie',url,Dom.window),
                    access_token = getQueryStr('access_token',url,Dom.window),
                    openid       = getQueryStr('openid',url,Dom.window);
    
                var login = {
                    uin             : uin,
                    key             : key,
                    pass_ticket     : pass_ticket,
                    set_cookie      : obj.set_cookie,
                    abtest_cookie   : abtest_cookie,
                    openid          : openid,
                    access_token    : access_token
                };
    
                return login;
            },
    
            /**
             * 对于新版本，处理cookie逻辑。
             *
             * @param {*} gotCallback
             * @param {*} qbInstance
             * @param {*} callback 如果cookie没成功，就采用原来的方案登陆 。
             */
            runCookie:function(gotCallback,qbInstance,callback){
                var that = this;
                
                var _cookieFn = function(from){
    
                    var login = {
                        uin             : '',
                        key             : '', 
                        pass_ticket     : '',
                        set_cookie      : '',
                        abtest_cookie   : '',
                        openid          : '',
                        from            : from,
                        cookie_passkey  : cookie_passkey 
                    }
                    that.loginTrigger(gotCallback,login,qbInstance);
                    
                    callback && callback(true);
    
                    qbInstance.EndLogic({
                        err_msg:'runCookie_' + from
                    });
                };
                _cookieFn.called = false;
    
                window.__GAME_LOGIN_CALLBACK = function(_cookie){
                    qbInstance.EndLogic({
                        err_msg:'runCookie_wait_logincallback_success'
                    });
                    if( !_cookieFn.called ){
                        _cookieFn('__GAME_LOGIN_CALLBACK');
                        _cookieFn.called = true;
                    }
                };
    
                var cookie_passkey = Cookie.cookie_get('cookie_passkey');
                if( '1' === cookie_passkey+'' ){
                    if( !_cookieFn.called ){
                        _cookieFn('cookie');
                        _cookieFn.called = true;
                    }
                }else{
                    qbInstance.EndLogic({
                        err_msg:'runCookie_wait_logincallback'
                    });
                }
            },
    
    
            canUseCookie:function(){
                /** 20200415 禁用一下，等等客户端发布。先禁用cookie方案 
                return {
                    status:false,
                    msg:'no support'
                };
                */
               /** 20200421 增加安卓版本rc能力，支持cookie */
                var vcompare = -1;
                if(Env.isAndroid) {
                    vcompare = Env.hexVersionCompare(Env.getHexClientVersion(), Versions.AndroidHexCookieVersion);
                }else {
                    vcompare = Env.versionCompare(Env.clientVersion(true), Versions.iosCookieVersion);
                }
    
                // 临时屏蔽极简版cookie方案，验证cookie登录态带来的效果
                if( location.pathname.indexOf("litecenter/index.html") > -1 ) {
                    vcompare = -1;
                }
    
                /**兼容PC，pc上没有version，会得到 vcompare null */
                if( isNaN(vcompare) ){
                    return {
                        status:false,
                        msg:'version illegal'
                    };
                }
                /** 安卓非luggage不支持。 */
                if(Env.isAndroid && !Env.isLuggage){
                    return {
                        status:false,
                        msg:'luggage illegal'
                    };
                }
                // ios有bug，屏蔽
                if( Env.isiOS ){
                    // if (typeof window.__INITIAL_STATE__ !== 'undefined' ) { // 预渲染的页面，使用cookie方案
                    //     return {
                    //         status: true,
                    //         msg: 'version ok'
                    //     }
                    // }
                    return {
                        status:false,
                        msg:'ios not support'
                    };
                }
    
                if( vcompare < 0 ){
                    return {
                        status:false,
                        msg:'version lower'
                    }
                }else{
                    return {
                        status:true,
                        msg:'version ok'
                    }
                }
            },
            /**
             * 是wepkg时，走这个函数，
             *
             * @param {any} getLoginFn
             */
            runWepkg:function(getLoginFn,context,qbInstance){
                var that = this;
                /*
                * @desc
                */
                window.beforeBridgeReady = (new Date()).getTime();
                qbInstance.startJsbridgeReady = Date.now();
                _callAfterReady(function(bridge) {
                    window.bridgeReadyTime3 = (new Date()).getTime();
    
                    window.beforeGetA8Key = (new Date()).getTime();
    
                    qbInstance.endJsbridgeReady = Date.now();
                    JsapiLog.logInfo('getUinKey','start call wxBridge.getA8key');
    
    
                    qbInstance.startGetA8KeyTime = Date.now();
                    wxBridge.getA8key(function(res,from){
                        // window.getA8keyEndTime = (new Date()).getTime();
                        qbInstance.endGetA8KeyTime = Date.now();
                        /**
                         * 从jsbridg中取出登陆态url.
                         */
    
                        var login = that.buildLoginByObj( res );
    
                        login.from       = from;
                        login.fullFilled = true;
    
                        JsapiLog.logInfo('getUinKey','end call wxBridge.getA8key',login);
    
                        getLoginFn && getLoginFn.call(wxBridge,login);
                    });
                });
            },
    
            loginTrigger:function(gotCallback,login,qbInstance){
                var that = this;
    
                /** 应举哥要求，增加获取 登陆态用户的性能时间。20200224 */
                qbInstance.endGetUinKeyTime = Date.now();
                if( !this.getUinKeyTimeReported ){
                    this.getUinKeyTimeReported = true;
    
                    wxBridge.callAfterReady(function(){
                        qbInstance.EndLogic({
                            from                : login.from || 'default',
                            cost_time           :
                                qbInstance.endGetUinKeyTime -
                                qbInstance.startGetUinKeyTime,
    
                            jsbridge_ready_time :
                                (qbInstance.endJsbridgeReady    || 0) -
                                (qbInstance.startJsbridgeReady  || 0),
    
                            a8key_time          :
                                ( qbInstance.endGetA8KeyTime    || 0) -
                                ( qbInstance.startGetA8KeyTime  || 0),
    
                            err_msg:'check_time'
                        });
                        
                    }.bind(that));
                }
    
                JsapiLog.logInfo('getUinKey','last login',login);
    
    
                var isFull =(  !!login &&
                    !!login.uin &&
                    !!login.key &&
                    !!login.pass_ticket);
                /**
                 * 做一下getUinKey的出错上报。只做一下wepkg下的上报。
                 */
                var isCookie = ( 
                    (login.set_cookie + '')     === '1' || 
                    (login.cookie_passkey + '') === '1'
                );
                if(Env.isWepkg() ){
                    if( !isFull && !isCookie ){
    
                        wxBridge.callAfterReady(function(){
                            qbInstance.EndLogic({
                                err_msg:'getUinKey'
                            });
                        });
                    }
                }
    
    
                if( window.performance &&
                    window.performance.timing.navigationStart  &&
                    (!window.WxGamePerformanceParams || !window.WxGamePerformanceParams["GetUinkeyTime"]) ){
    
                    window.WxGamePerformanceParams = window.WxGamePerformanceParams || {};
                    window.WxGamePerformanceParams["GetUinkeyTime"] = new Date().getTime() - window.performance.timing.navigationStart;
                }
                try{
                    login.cost_time = qbInstance.endGetUinKeyTime - qbInstance.startGetUinKeyTime;
                    gotCallback && gotCallback.call(wxBridge,login);
                }catch(e){
                    console.error('loginTrigger',e);
                }
            },
            urlFullLogin:function(){
                var that = this;
                /**
                 * 安卓8.0.22，在会话中打开页面时，getA8key变成异步了，会导致url不会自动拼登录态参数
                 * 此时如果链接自身带了错误的登录态参数，使用这些登录态参数会有问题
                 * 这种场景强制不使用url里面的登录态参数
                 * */  
                if( Env.isAndroid && Env.getHexClientVersion() >= 0x28001600) {
                    return {
                        isFull: false,
                        login: {}
                    }
                }
                /**
                 * 从URL中取一下登陆态。不管有没有 wechat_pkgid in url
                 */
                var obj = {full_url : null, set_cookie : ''}
                var login = that.buildLoginByObj(obj,'url');
                var isFull =    login.uin.length > 0 &&
                                login.key.length > 0 &&
                                login.pass_ticket.length > 0
                return {
                    isFull: isFull,
                    login : login
                };
            },
            /**
             * 获取登陆态。。。。
             *
             * @param {any} gotCallback
             */
            getUinKey:function(gotCallback){
                var that = this;
    
                /**
                 * 支持一下 第三方页面，非微信下的登陆态
                 */
                if( !Env.isWechat){
                    var accessTokenLogin = that.buildLoginByObj({});
                    if( !!accessTokenLogin.access_token ){
                        gotCallback && gotCallback(accessTokenLogin);
                        return;
                    }
                }
    
                
                /**
                 * 做一下getUinKey的出错上报。
                 */
                var WXGAME  = window.WXGAME        || {};
                var qualityBase = WXGAME.baseQualityReport || _qualityBase;
                var qbInstance = qualityBase.StartRunner(
                    'wxBridge.getUinKey',{},null
                );
    
                qbInstance.startGetUinKeyTime = Date.now();
                
                /**
                 * 这是使用cookie方案前的逻辑 。
                 * 既保障之前的运行，也要兼容cookie方案。
                 * @returns
                 */
                var queueUinKeyFn = function (canUseCookie){
                    if( Dom.window.gotLogin ){
                        // 成功逻辑，对问题定位无帮助【删除】
                        // JsapiLog.logInfo('getUinKey','Dom.window.gotLogin:',Dom.window.gotLogin);
                        var login = Dom.window.gotLogin;
                        login.from = 'memcache';
                        that.loginTrigger(gotCallback,login,qbInstance);
                        return;
                    }
        
        
                    Dom.window.getUinKeyQueue.run({
                        fn:function(){
                            var context = this;
                            // 判断当前是否离线包，可通过客户端日志查询的得到【删除】
                            // JsapiLog.logInfo('getUinKey','__usewepkg__:',window.__usewepkg__);
        
                            var isWepkg = Env.isWepkg();
                            if( isWepkg ){
                                // 判断当前是否离线包，可通过客户端日志查询的得到【删除】
                                // JsapiLog.logInfo('getUinKey','isWepkg:',isWepkg);
        
                                var notReturnTimer = setTimeout(function(){
                                    JsapiLog.logInfo('getUinKey','runWepkgTimeout:',15000);
                                    wxBridge.callAfterReady(function(){
                                        qbInstance.EndLogic({
                                           err_msg:'runWepkgTimeout:15000'
                                        });
                                    });
                                    context.done({
                                        uin             : '',
                                        key             : '',
                                        pass_ticket     : '',
                                        set_cookie      : '',
                                        abtest_cookie   : '',
                                        openid          : '',
                                        access_token    : '',
                                        fullFilled      : false
                                    });
                                },15000);
                                //这里强烈信任这个标记。
                                that.runWepkg(function(login){
                                    clearTimeout(notReturnTimer);
                                    context.done(login);
                                },context,qbInstance);
                            }else{
                                /**
                                 * isWepkg = false，有以下 完备 情况：
                                 * 1、完全外网，未抹登陆态。
                                 * 2、完全外网，抹了登陆态。—— 但这个状态，前端并不能判定。
                                 * 3、是 wepkg 但获取标记出错，因客户端原因。
                                 */
                                /**
                                 * 从Url中取。不论什么情况，如果全，那就先用。不管它是否wepkg
                                 * 为了修安卓下的bug
                                 * */
                                var urlLoginObj = that.urlFullLogin();
                                // 该日志多余，多个分支情况都各自打日志了【删除】
                                // JsapiLog.logInfo('getUinKey',urlLoginObj,' see urlFullLogin  fullfilled status');
                                if( urlLoginObj.isFull || Env.isMSDK){
                                    //没抹登陆态
                                    JsapiLog.logInfo(
                                            'getUinKey','isWepkg:' + isWepkg,
                                            ' login all in querystr，first get from url');
        
        
        
                                    var login           = urlLoginObj.login;
                                    login.fullFilled    = true;
                                    login.from          = 'url';
                                    context.done(login);
                                }else{
                                    /**
                                    * 非离线包场景下，且页面url里面没有完整登录态参数的话，会走到这里逻辑主要有几种：
                                    * 1. 抹登录态场景（但这种场景现网已经不会再有）
                                    * 2. 非gamewebview的页面重定向到game页面时，没有加#wechat_redirect，只有uin和key参数，缺少passticket(但这种情况下页面打开是非gamewebivew，getWepkgAuthResult调用是会失败的)
                                    * 3. 安卓预加载场景，geta8key是异步的，此时getWepkgAuthResult接口调用有问题
                                    * 4. iOS jscore预渲染情况，登录态参数不会拼url，并且写cookie中的逻辑有bug
                                    * 
                                    * 综上，走到的这里时，不做任何处理，让页面请求走cookie，是最好的处理逻辑
                                    */
                                    function done() {
                                        JsapiLog.logInfo(
                                            'getUinKey', 'isWepkg:false',
                                            ' login url is not full,try run cookie');

                                        var obj = { full_url: null, set_cookie: '' }
                                        var login = that.buildLoginByObj(obj, 'url');

                                        login.fullFilled = true;
                                        login.wipeLogin = true;
                                        login.from = 'url';
                                        context.done(login);
                                    }
                                    if ( canUseCookie ) { // 可用cookie情况下
                                        var cookieNotReturnTimer = setTimeout(function () {
                                            qbInstance.EndLogic({
                                                err_msg: 'runCookie:1200'
                                            });
                                            done();
                                        }, 1200); 
                                        that.runCookie(function (login) {
                                            context.done(login);
                                        }, qbInstance, function(res) {
                                            if (true === res) {
                                                clearTimeout(cookieNotReturnTimer);
                                            }
                                        })
                                    } else if (typeof window.__INITIAL_STATE__ !== 'undefined') { // 已预渲染的页面， ios下没开cookie开关，只能走jsapi来获取
                                        qbInstance.EndLogic({
                                            err_msg: 'runJsapiInJscore'
                                        });
                                        that.runWepkg(function (login) {
                                            context.done(login);
                                        }, context, qbInstance);
                                    }else {
                                        done();
                                    }
        
                                }
                            }
        
                        },
                        backFn:function(login){
                            Dom.window.gotLogin = login;
                            that.loginTrigger(gotCallback,login,qbInstance);
                        }
                    });
                };
                /** canUseCookie = 版本符合，并且 cookie_passkey == '1' */
    
                var judgeResult = this.canUseCookie();
                // 每次使用登录态都会打，版本判断cookie是否可用，可通过版本信息直接看出【删除】
                // JsapiLog.logError('getUinKey','canUseCookie:',judgeResult);
                if( true == judgeResult.status && Env.isWepkg() ){ // 离线包才用cookie登录态，非离线包直接用qs就可以拿到
                    var cookieNotReturnTimer = setTimeout(function(){
                        qbInstance.EndLogic({
                            err_msg:'runCookie:1200'
                        });
                        queueUinKeyFn(true);
                    },1200); // https://git.code.oa.com/WGFE/commlib/issues/14 根据安卓获取cookie耗时分布情况，1200ms会比较合适
    
                    this.runCookie(gotCallback,qbInstance,function(res){
                        if( true === res){
                            clearTimeout(cookieNotReturnTimer);
                        }
                    });
                }else{
                    queueUinKeyFn(true == judgeResult.status);
                }
            }
        };

        /**
         * jsapi 鉴权模块。此文件，其它地方不会使用。
         */
        var VerifyJsapiModule = {
            _qrStr      : '',
            _opt        : {
                loaded:false,
                isTestEnv:false
            },
            _cbkQueue: [],
            callAfterLoaded:function(cbk) {
                if( typeof cbk !== 'function') {
                    return
                }
                if( this._opt.loaded ) {
                    cbk(this._opt)
                    return;
                }
                this._cbkQueue.push(cbk);
            },
            consumeCbkQueue: function(data) {
                for(var i = 0, len = this._cbkQueue.length; i < len; i++ ) {
                    let cbk = this._cbkQueue.shift();
                    cbk(data);
                }
            },
            /*
            * 根据login，设置一下QMAjax对象的一些必需值，比如url method，设置
            * 完后，就不管了，没它的事了。也没返回值。
            */
            initQryStr:function(login, _qajax) {
                var _url = '/cgi-bin/comm/genfun?';
                _qajax.uin = login.uin;
                _qajax.key = login.key;
                _qajax.pass_ticket = login.pass_ticket;
                this._qrStr = [
                    'uin=' + _qajax.uin,
                    'key=' + _qajax.key,
                    'pass_ticket=' + _qajax.pass_ticket
                ].join('&');
    
                var _qrStr = this._qrStr;
    
                _qajax.loginStr = _qrStr;
                _qajax.from    = login.from;
    
                _qajax.Referer = 'Referer=' + encodeURIComponent(
                    location.href.split('#')[0]
                );
                /**
                 * 这里用post是因为，有些页面，html里，禁用了referer,所以
                 * 只能选择post
                 */
                // _qajax.method = _qajax.Referer != undefined ? 'POST' : 'GET';
                _qajax.method = 'GET';
                _qajax.url = _url + _qrStr + '&' + _qajax.Referer + '&_=' + Math.random();
            },
    
            ajaxGenFun:function(prelogin,jsapiArr,cbk){
                var that = this;
                // 客户端会打日志【删除】
                // JsapiLog.logInfo('ajaxGenFun',' start ajaxGenFun in login_queue');
                
    
    
                /*
                * 向后台genfun接口发出请求，获取签名，
                * 将签名传入到客户端中校验，获得jsapi的使用权
                */
                var _qajax = new QMAjax();
                /**
                 * 设置一下QMAjax的相关参数。
                 */
                that.initQryStr(prelogin, _qajax);
    
                /**
                 * 单独监控 genfun cgi 质量。
                 */
                var WXGAME  = window.WXGAME        || {};
                var qualityBase = WXGAME.baseQualityReport || _qualityBase;
                var genfunInstance = qualityBase.StartLogic(
                    qualityBase.LOGIC_CONST.TypeTextEnum.CGI,
                    _qajax.url,{},null
                );
    
    
                if(window.ReportLuggage && window.NavigationStart){
                    window.ReportLuggage.genfunBgn(
                        new Date().getTime() - window.NavigationStart,
                        new Date().getTime(),
                        window.NavigationStart
                    );
                }
                _qajax.onComplete = function (xhr) {
    
                    /**
                     * 发现使用 genfun cgi complete数
                     */
    
                    if(window.ReportLuggage && window.NavigationStart){
                        window.ReportLuggage.genfunEnd(
                            new Date().getTime() - window.NavigationStart,
                            new Date().getTime(),
                            window.NavigationStart
                        );
                    }
                    if (xhr.responseText.indexOf('{') != -1) {
                        var res = JSON.parse(xhr.responseText);
                        if (res.ret == 0) {
                            that._opt.sign          = res.data.jsapi_sign;
                            that._opt.sign.loginStr = _qajax.loginStr;
                            that._opt.sign.uin      = _qajax.uin;
                            that._opt.sign.key      = _qajax.key;
                            that._opt.sign.pass_ticket = _qajax.pass_ticket;
                            that._opt.sign.from     = _qajax.from;
                            that._opt.loaded        = true;
                            that._opt.isTestEnv     = !!res.data.is_test_env;

                            that.consumeCbkQueue(that._opt);
                            
                            // 成功分支【删除】
                            // JsapiLog.logInfo(
                            //         'ajaxGenFun',res,
                            //         ' call genfun success and start call wxBridge.verifyCall'
                            //     );
    
    
                            /**
                             * 发现使用 genfun cgi complete 并 ret 为0 数，并开始调用 wxBridge.verifyCall数
                             */
    
                            wxBridge.verifyCall(jsapiArr, this._opt.sign, function(bret,res){
    
                                /*
                                * ajaxGenFun 的回调数 2
                                */
    
                                try {
                                    cbk && cbk(bret,res);
                                } catch (error) {
                                    console.error('Your wxBridge.ajaxGenFun callback runtime error ',error);
                                }
                            });
                        } else {
                            /**
                             * 发现使用 genfun cgi complete 并 ret 不为 0 数
                             */
    
                            
                            genfunInstance.EndLogic({
                                ret: res.ret,
                                res: res,
                                err_msg:'errcode_'+res.ret
                            });
    
                            /*
                            * ajaxGenFun 的回调数 3
                            */
    
                            cbk && cbk(false, {
                                err_code    : 1,
                                loginStr    : _qajax.loginStr,
                                uin         : _qajax.uin,
                                key         : _qajax.key,
                                from        : _qajax.from,
                                pass_ticket : _qajax.pass_ticket,
                                err_msg     : 'async signature load error'
                            });
                            JsapiLog.logError(
                                    'ajaxGenFun',res,
                                    ' call genfun fail for ret not 0'
                                );
                            that.consumeCbkQueue();
                        }
                    }else{
                        var res = JSON.parse(xhr.responseText);
                        /**
                         * 发现使用 genfun cgi complete 并 json error 数
                         */
    
    
                        /*
                        * ajaxGenFun 的回调数 4
                        */
    
                        genfunInstance.EndLogic({
                                ret: res.ret,
                                res: res,
                                err_msg:'errcode_not_json'
                            });
                        cbk && cbk(false, {
                            err_code    : 2,
                            loginStr    : _qajax.loginStr,
                            uin         : _qajax.uin,
                            key         : _qajax.key,
                            from        : _qajax.from,
                            pass_ticket : _qajax.pass_ticket,
                            err_msg     : 'genfun responseText illegal'
                        });
                        that.consumeCbkQueue();
                    }
                    _qajax = null;
                }.bind(that);
                _qajax.onError = function (xhr, err_code) {
    
                    /**
                     * 发现使用 genfun cgi onError数
                     */
    
                    genfunInstance.EndLogic({
                        ret: err_code,
                        res: xhr,
                        err_msg:'errcode_onError_' + err_code
                    });
                    /*
                    * ajaxGenFun 的回调数 5
                    */
    
    
                    cbk && cbk(false, {
                        err_code        : -1,
                        xhr             : xhr,
                        loginStr        : _qajax.loginStr,
                        uin             : _qajax.uin,
                        key             : _qajax.key,
                        pass_ticket     : _qajax.pass_ticket,
                        err_msg         : err_code
                    });
                    _qajax = null;
    
                    JsapiLog.logError('ajaxGenFun',err_code,' call genfun fail for timeout');
                    that.consumeCbkQueue();
    
                }.bind(that);
                _qajax.send(_qajax.Referer ? _qajax.Referer : null);
    
            },
    
            checkIsPreVerified:function(checkedMap,jsapiArr){
                var isAllVerified = true;
                checkedMap = checkedMap || {};
                for(var i=0,len=jsapiArr.length; i<len;i++){
                    if( !checkedMap[jsapiArr[i]] ){
                        isAllVerified = false;
                        return isAllVerified;
                    }
                }
                return isAllVerified;
            },
            /**
             * jsapi鉴权。
             *
             * @param {any} jsapiArr
             * @param {any} cbk
             */
            verifyJsapi:function(jsapiArr,cbk){
                var that = this;
                // 对定位问题无帮助+后续prevify流程会移除【删除】
                // JsapiLog.logInfo('verifyJsapi',jsapiArr,' start call verifyJsapi from stack');
    
    
                /** 兼容一下非微信下的场景 。 */
                if( !Env.isWechat ){
                    cbk && cbk(true,{
                        err_msg:'preverifyJSAPI:ok'
                    });
                    return;
                }
                /*
                 *   verrifyjsapi启动调用数
                */
    
                /**
                 * 质量 wxBridge.verifyJsapi 接口 上报开始。。
                 */
                var WXGAME  = window.WXGAME        || {};
                var qualityBase = WXGAME.baseQualityReport || _qualityBase;
                var qbInstance = qualityBase.StartRunner(
                    'wxBridge.verifyJsapi',{},null
                );
                // 对定位问题无帮助+后续prevify流程会移除【删除】
                // JsapiLog.logInfo('verifyJsapi',Dom.window.verifyJsapiQueue,' view queue');
    
                Dom.window.verifyJsapiQueue.run(function(verifiedMap){
    
                    var context = this;
                    var isAllVerified = that.checkIsPreVerified(
                        Dom.window.verifyJsapiQueue.verifiedMap,
                        jsapiArr
                    );
    
                    // console.error('isAllVerified',isAllVerified,Dom.window.verifyJsapiQueue.verifiedMap,jsapiArr);
                    if( isAllVerified ){
                        //说明第一次verify回来过。并且当前全部verify过。
                        try {
    
                            var allVerifiedRes = Dom.window.verifyJsapiQueue.verifiedMap.res;
                            allVerifiedRes.from = 'allVerified';
    
                            qbInstance.EndLogic({
                                err_msg : allVerifiedRes.from
                            });
    
    
                            context.done(verifiedMap);
                            cbk && cbk(
                                true,
                                allVerifiedRes
                            );
    
                        } catch (error) {
                            var errStr = 'verifyJsapi callback runtime error';
                            console.error(errStr,error);
                            qbInstance.EndLogic({
                                err_msg : errStr
                            });
                            context.done(verifiedMap);
                        }
    
                        return;
                    }else{
                        LoginModule.getUinKey(function(login){
                            // 对定位问题无帮助+后续prevify流程会移除【删除】
                            // JsapiLog.logInfo('verifyJsapi',login,' start call ajaxGenFun in login_queue');
    
    
                            that.ajaxGenFun(login,jsapiArr,function(code,res){
                                // 对定位问题无帮助+后续prevify流程会移除【删除】
                                // JsapiLog.logInfo('verifyJsapi',code, res ,' end call ajaxGenFun in login_queue');
    
    
                                if( !code ){
                                    /**
                                     * 质量 wxBridge.verifyJsapi 接口 上报 结束。。
                                     */
                                    qbInstance.EndLogic({
                                        err_msg:{
                                            code    :code,
                                            res     :res
                                        }
                                    });
                                }
    
                                var cverifiedMap = Dom.window.verifyJsapiQueue.verifiedMap || {};
                                if( true === code ){
                                    for(var i=0,len=jsapiArr.length;i<len;i++){
                                        cverifiedMap[jsapiArr[i]] = true;
                                    }
                                }
                                cverifiedMap.res = res;
                                Dom.window.verifyJsapiQueue.verifiedMap = cverifiedMap;
                                context.done(cverifiedMap);
    
                                /* genfun总的回来数 */
                                qbInstance.EndLogic({
                                    err_msg:"wxBridge.verifyJsapi ends"
                                });
                                try {
                                    cbk && cbk.call(wxBridge,code,res);
                                } catch (error) {
                                    var errStr = 'getUinKey genFun wxBridge.verifyJsapi callback runtime error ';
                                    console.error(errStr,error);
                                    qbInstance.EndLogic({
                                        err_msg : errStr
                                    });
                                }
    
                            }.bind(that));
                        }.bind(that));
                    }
                });
    
            }
        };

        /*
         * 暴露接口 getUinKey
         */
        /**
         * getUinKey获取登录态信息
         * 检查是否是离线包：如果是，就在在ready以后getA8Key获取登录态信息
         * 否则就从url上面获取
         * @static
         * @function getUinKey
         * @param {callback} cbk                  - 获取到登录态信息以后的回调函数
         * @param {Object} cbk.login              - 登录态信息对象
         * @param {string} cbk.login.uin          - uin
         * @param {string} cbk.login.pass_ticket  - pass_ticket
         * @param {string} cbk.login.key          - key
         * @param {string} cbk.login.from         - 登录态获取来源（geta8key, url...）
         * @param {string} cbk.login.set_cookie   - 是否设置cookie
         *
         * @example
         * var wxBridge = require('jsbridge/jsbridge_login_queue').default;
         * wxBridge.getUinKey(function(login) {
         *    ajax(cgi, ....);
         * })
         */
        wxBridge.getUinKey      = LoginModule.getUinKey.bind(LoginModule);


        /*
         * 暴露接口 callAfterReady
         */
        /**
         * callAfterReady 确保回调函数是在wxBridge准备好了以后执行
         * @static
         * @function callAfterReady
         * @param {callback} cbk                   - 回调函数没有参数传入
         * @example
         * var wxBridge = require('jsbridge/jsbridge_login_queue').default;
         * wxBridge.callAfterReady(function() {
         *      // do something after wxBridge ready
         * })
         */
        wxBridge.callAfterReady = _callAfterReady;


        /*
         * 暴露接口 verifyJsapi
         */
        /**
         * 校验jsapis接口后执行函数
         * @static
         * @function verifyJsapi
         * @param {Array}     jsapiArr                  -  需要校验的jsapi接口数组
         * @param {callback}  callback                  -  校验以后的回调函数，将会传入一些参数
         * @param {boolean}   callback.isValid          -  校验是否成功有效
         * @param {Object}    callback.opt              -  回调的函数值
         * @param {string}    callback.opt.err_code     - 错误码
         * @param {string}    callback.opt.err_msg      - 错误信息
         * @param {string}    callback.opt.uin          - uin
         * @param {string}    callback.opt.key          - key
         * @param {string}    callback.opt.pass_ticket  - pass_ticket
         * @param {string}    callback.opt.loginStr     - 登录态string
         * @param {string}    callback.opt.xhr          - 请求的对象
         *
         * @example
         * var wxBridge = require('jsbridge/jsbridge_login_queue').default;
         * wxBrdige.verifyJsapi(wxBridge.apis, function(boo, opt) {
         *      if (boo) {
         *          // verify ok
         *          // do something
         *      } else {
         *          // verify fail
         *          // log or report
         *      }
         * })
         */
        wxBridge.verifyJsapi    = VerifyJsapiModule.verifyJsapi.bind(VerifyJsapiModule);
        wxBridge.VerifyJsapiModule = VerifyJsapiModule;

        wxBridge.initMpInfo = () => {
            let version = Env.getHexClientVersion();
            // 负一屏能力版本: ios >= 0x18000000, 安卓 >= 0x28000000
            if (Env.isiOS && version < 0x18000000) {
                return
            }
            if (Env.isAndroid && version < 0x28000000) {
                return
            }
            wxBridge.verifyJsapi(["currentMpInfo"], () => {
                wxBridge.invoke(
                    'currentMpInfo',
                    {
                        brandIcon:
                            'https://res.wx.qq.com/wechatgame/product/webpack/userupload/20210115/163913/gamecenter-logo.png',
                        brandName: '微信游戏',
                    },
                    (res) => {}
                );
            })
        }

        var ret;
        if ( win['WXGAME'] && win['WXGAME'].WxBridge ) {
            ret = win['WXGAME'].WxBridge
        } else {
            ret = wxBridge;
        }
        exportData = ret;
    })(window);
    
} else {
    exportData = {};
}
export default exportData;
